import React from "react";
import StyledHeader from "../../components/StyledHeader";
import errorCaution from "../../../public/images/svg/errorCaution.svg";
import { GENERIC_ERROR_TEXT } from "@/constants";

const ErrorPage = (props: {
  title: string;
  message: string;
  details?: string;
}) => {
  const { title, message, details } = props;

  // const apiUrl: string = AppSettingsService.getBaseUrl();
  // const isNonProd: boolean =
  //   apiUrl.includes("costco.internal") ||
  //   apiUrl.includes("localhost") ||
  //   apiUrl.includes("np.ct-costco.com");
  return (
    <div>
      <StyledHeader />
      <div className="pt-12 bg-gray-100 h-screen justify-center text-center text-CostcoAction">
        <div className="mx-auto max-w-4xl">
          <div className="pb-5">
            <div className="flex justify-center items-center pt-20 pb-5">
              <img
                className="w-[100px]"
                src={errorCaution}
                alt="errorCaution"
              />
            </div>
            <div className="tracking-widest mt-4">
              <div className="text-5xl block">{GENERIC_ERROR_TEXT}</div>
              <div className="pt-16 text-lg">{title}</div>
              <div className="flex justify-center items-center py-5">
                {message}
              </div>
              {details !== undefined && (
                <div className="pt-5 text-lg">{details}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
